import { FC, PropsWithChildren, useEffect, useMemo, useState } from "react";
import { Tooltip } from "react-tooltip";
import { globalCss } from 'stitches';
import { SwedishTheme } from '../../../../../packages/stitches/themes/seTheme';
import { useUserContext } from "../User/User.hooks";
import { AppContext, IAppContextType, ITopbarState } from "./App.context";

export const AppProvider: FC<PropsWithChildren> = ({ children }) => {
  globalCss();

  const [topBarState, setTopBarState] = useState<ITopbarState>({});
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const { currentLanguage } = useUserContext();

  useEffect(() => {
    if (currentLanguage === "dk") {
      document.documentElement.classList.add(SwedishTheme);
    } else {
      document.documentElement.classList.remove(SwedishTheme);
    }
  }, [currentLanguage]);

  const toggleSidebar = () => setIsSidebarCollapsed((prev) => !prev);

  const AppContextValue: IAppContextType = useMemo(
    () => ({
      topBarState,
      setTopBarState,
      isSidebarCollapsed,
      toggleSidebar,
    }),
    [topBarState, isSidebarCollapsed],
  );

  return (
    <AppContext.Provider value={AppContextValue}>
      <Tooltip id="tooltip" className="tooltip" />
      {children}
    </AppContext.Provider>
  );
};
